// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"535":"44dccceb","675":"41b61fbf","748":"c1748e98","904":"1750ab58","922":"1382ea79","931":"ac566a80"}[chunkId] + ".chunk.js";
};